export default __webpack_public_path__ + "static/media/17_3Egreen.a65cc2dd.png";